import { useI18n } from '../i18n/useI18n';

interface Props {
  song: string;
  onDismiss: () => void;
}

export default function UpNextBanner({ song, onDismiss }: Props) {
  const { t } = useI18n();

  return (
    <div className="up-next-banner">
      <span>{t('stage.upNext', { song })}</span>
      <button className="up-next-banner__dismiss" onClick={onDismiss}>
        {t('ui.dismiss')}
      </button>
    </div>
  );
}
